<template>
  <div class="this-contact page">
    <div class="title page-title">
      {{ $t('contact.title') }}
    </div>
    <div class="text">
      {{ $t('contact.text') }}
    </div>
    <form ref="contactForm" @submit="sendMail">
      <input class="input-form name" :placeholder="$t('contact.form.name')"
             id="name" v-model="name" type="text" />

      <input class="input-form email" :placeholder="$t('contact.form.email')"
             id="email" type="email" v-model="email" required />

      <input class="input-form subject" :placeholder="$t('contact.form.subject')"
             id="subject" v-model="subject" type="text"   />

      <textarea class="input-form message" :placeholder="$t('contact.form.text')"
                id="message" v-model="message" required></textarea>
      <div class="submit">
        <button class="btn-default" :disabled="sending">{{ $t('contact.form.submit') }}</button>
      </div>
    </form>
  </div>
</template>

<script>
  import PublicService from "../Services/publicService";

  export default {
  name: 'Contact',
  props: {},
    data: () => {
      return {
        sending: false,
        email: '',
        name: '',
        subject: '',
        message: ''
      }
    },
  methods: {
    sendMail: function() {
      this.sending = true;
      PublicService.sendMail({
        name: this.name,
        email: this.email,
        subject: this.subject,
        message: this.message
      }).then(response => {
        if (response.status === 200) {
          this.name = '';
          this.email = '';
          this.subject = '';
          this.message = '';
          this.$refs.contactForm.reset();
          this.$toast.add({severity: 'success', summary: this.$t('contact.toasts.summary.success'),
            detail: this.$t('contact.toasts.detail.success'), life: 3000});
        } else {
          this.$toast.add({severity: 'error', summary: this.$t('contact.toasts.summary.error'),
            detail: this.$t('contact.toasts.detail.error'), life: 3000});
        }
        this.sending = false;
      }).catch((error) => {
        this.sending = false;
        console.error(error);
        this.$toast.add({severity: 'error', summary: this.$t('contact.toasts.summary.error'),
          detail: this.$t('contact.toasts.detail.error'), life: 3000});
      });
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import 'src/assets/styles/variables';

  .this-contact {
    background-color: $mainColor;

    .title, .text {
      text-align: center;
    }
    form {
      margin-top: 50px;
      display: grid;
      grid-gap: 20px;
      align-self: center;
      grid-template-rows: 1fr 1fr 1fr 1fr;
      grid-template-columns: 1fr 1fr;
      grid-template-areas:
        "name message"
        "email message"
        "subject message"
        "submit submit";

      .input-form {
        margin-bottom: 20px;
        color: #999;
        border: 1px solid #eeeeee;
        border-radius: 0;
        padding-left: 20px;
        height: 100%;

        &.name {
          grid-area: name;
        }
        &.email {
          grid-area: email;
        }
        &.subject {
          grid-area: subject;
        }
        &.message {
          grid-area: message;
          padding: 10px 20px;
        }
      }
      .submit {
        grid-area: submit;
        text-align: center;
        .btn-default {
          border-color: $white;
          color: $white;
        }
        .btn-default:hover {
          background-color: $white;
          color: $secondaryColor;
        }
      }
    }
  }

  /* mobile */
  @media (max-width: 640px) {
    .this-contact {
      form {
        grid-template-rows: 1fr 1fr 1fr 3fr 1fr;
        grid-template-columns: 1fr;
        grid-template-areas:
        "name"
        "email"
        "subject"
        "message"
        "submit";
      }
    }
  }
</style>
